module.exports = __webpack_public_path__ + "img/bo_concept_mobile_hero_billede_new.659ee17b.png";